<template>
  <div class="home">
    <div class="primary-title" style="margin-top: 0px">
      <v-layout row wrap>
        <div class="mt-2">工作首頁</div>
      </v-layout>
    </div>

    <base-tag tag-name="證照資料">
      <template v-slot:content>
        <div class="text-bold">壽險登錄證字號：{{ licenseNo }}{{ license }}</div>
      </template>
    </base-tag>

    <base-tag tag-name="訊息公告" class="mt-3">
      <template v-slot:content>
        <!-- <div v-html="wobMsg"></div> -->
        <div  style="text-align: left">
          {{ marqueeStr }}
        </div>
      </template>
    </base-tag>

    <!-- <div class="primary-title">
      快捷服務
    </div>
    <v-item-group>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex md6>
            <v-item>
              <v-card class="align-center justify-center d-flex border-active"
                      height="110"
                      @click="go">
                <div class="layout justify-center align-center">
                  <img class="tab-icon"
                       src="@/assets/group_iconHomeA.svg">
                  <div class="title-name">要保書查詢</div>
                </div>
              </v-card>
            </v-item>
          </v-flex>
          <v-flex md6>
            <v-item>
              <v-card class="align-center justify-center d-flex border-active"
                      height="110"
                      @click="newPolicy">
                <div class="layout justify-center align-center">
                  <img class="tab-icon"
                       src="@/assets/group_iconHomeB.svg">
                  <div class="title-name">要保書新增</div>
                </div>
              </v-card>
            </v-item>
          </v-flex>
        </v-layout>
      </v-container>
    </v-item-group> -->

    <div class="primary-title">要保書待處理清單</div>
    <v-container grid-list-lg>
      <v-layout row
                wrap>
        <v-flex md6
                lg4
                v-for="(item, index) in searchResult"
                :key="index">
                <div class="d-flex touch-finger"  @click="selectItem(item.transCode)" style="background: #fff;padding: 10px;align-items: center;font-weight: bolder;height: 83px;justify-content: space-around;">
                <span style="text-align: left;max-width: 83px;min-width: 83px;flex: 1!important;">
                  <div style="max-height: 42px;overflow-y: hidden;"> {{item.oCusName === '' ? `---`:item.oCusName}}</div>
                  <div>
                  {{item.modifyDt === '' ? `---`:item.modifyDt}}</div>
                </span>
                 <div>
          <div style="background-color: #1d3a40;width: 140px;padding: 3px 12px;color: #fff;border-radius: 50px;font-weight: bolder;margin: 0px auto;word-break: keep-all;">{{replace(item.polStateName)}}</div>
        </div><span style="padding: 0 5px;max-width: 80px;min-width: 80px;word-break: break-all;">{{item.insAcceptNo=== '' ? `---`:item.insAcceptNo}}</span>
      </div>
        </v-flex>
      </v-layout>
    </v-container>

    <select-company
      v-if="companyToggle"
      :items="proCompanyList"
      :aCusIdn="cusIdn"
      @click="clickCompanyHandler"
      @close="closeCompanyHandler"
    ></select-company>

    <policy-container
      v-if="policyToggle && policyCompanyCode === 'CH'"
      :aCusIdn="cusIdn"
      @destory="policyToggleHandler"
    ></policy-container>
  </div>
</template>

<script>
// import axios from "axios";
import SelectCompany from "@/components/SelectCompany.vue";
import { mapState, createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("user");
const { mapActions: insMapActions } = createNamespacedHelpers("ins");

export default {
  name: "home",
  components: { SelectCompany },
  data() {
    return {
      marqueeBlank: "　　　　　　　　　　　　　　　　　　　　　　",
      marqueeStr: '',
      carryYn: "",
      count: 6,
      policyToggle: false,
      companyToggle: false,
      policyCompanyCode: "",
      proCompanyList: [],
      licenseNo: "",
      license: "",
      wobMsg: "",
      policyItems: [],
      userName: "",
      userCode: "",
      cusIdn: "",
      branCodeRoleList: [],
      branCodeRole: null,
      inWorkTime: true,
      intervalId: null, //data 定義一個定時器id
      searchResult: []
    };
  },
  watch: {
    branCodeRole: {
      handler(newVal, oldVal) {
        if (
          newVal &&
          oldVal &&
          (newVal.roleCode !== oldVal.roleCode ||
            newVal.branCode !== oldVal.branCode)
        ) {
          this.changeBranCodeRole({
            branCode: newVal.branCode,
            roleCode: newVal.roleCode,
          }).then((r) => {
            window.location.reload();
          });
        }
      },
    },
  },
  computed: {
    repolicyItems() {
      // const policyItemsLength = this.policyItems.length
      let newArray = this.policyItems.slice(0, this.count);
      console.log(newArray);
      return newArray;
    },
    ...mapState({
      timer: "timer",
    }),
  },
  mounted() {
    // this.$api.get("/public/getVer").then((r) => {
    //   console.log("api ver:" + r.data);
    // });
    // axios.get("ver.txt").then((r) => {
    //   console.log("ui: " + r.data);
    // });
  },
  created() {
    // PRO_COMP-S01(保險公司服務)
    this.$api
      .get("/pro/proCompanyies", {
        params: {
          queryString: "",
        },
      })
      .then((r) => {
        this.proCompanyList = r.data;
      });

    var servMsg = localStorage.getItem("servMsg");
    if (servMsg === null) {
      this.$api.get("/wob/servMsg2").then((r) => {
        if (r.data.length > 0) {
          // let msg=''
          localStorage.setItem("servMsg", "done");
          const msgData = r.data
          //  msgData.forEach(v => {
          //    msg=msg+v.srvCont + '<br>'
          // })
          let newMsg = this.changeMsg(msgData)
          this.$alert(
            newMsg,
            (yn) => {
              this.intiData();
            },
            {
              title: "系統公告",
              dialogWidth: 700,
              blackText: true,
              iconClose: true,
            }
          );
        } else {
          this.intiData();
        }
      });
    } else {
      this.intiData();
    }
    let userInfo = this.$store.getters["user/info"];
    this.carryYn = userInfo.carryYn;
  },
  methods: {
    ...mapActions(["featchBranCodeRole", "changeBranCodeRole"]),
    changeMsg (list) {
      let newMsg = ''
      if (list.length > 1) {
        let newList = []
        let num = 1
        list.forEach(el => {
          el.srvCont = '(' + num + ')'  + el.srvCont
          num++
          newList.push(el.srvCont)
          console.log(el)
        })
        newMsg = '<div style="text-align:left">' + newList.join('<br>') + '</div>'
        return newMsg
      } else {
        return '<div style="text-align:left">' + list[0].srvCont + '</div>'
      }
    },
    clickCompanyHandler(code) {
      this.policyCompanyCode = code;
      this.newPolicy(this.woCode);
      this.companyToggle = false;
    },
    closeCompanyHandler() {
      this.companyToggle = false;
    },
    newPolicy(woCode) {
      this.policyToggle = !this.policyToggle;
      this.insStepHandler({
        progClassName: "home_proposal_new",
        methodName: "首頁點選要保書新增",
        stepCode: "",
        woCode: woCode,
      });
    },
    readMore() {
      this.count += 6;
    },
    policyToggleHandler() {
      this.policyToggle = !this.policyToggle;
      this.intiData();
    },
    go() {
      this.$router.push({
        name: "proposal",
        params: { aTransCode: this.transCode },
      });
      // this.insStepHandler({ progClassName: '', methodName: '首頁點選要保書查詢', stepCode: '' })
    },
    selectItem(transCode) {
      localStorage.setItem('aTransCode', transCode)
      this.$router.push({ path: 'proposal' })
    },
    intiData() {
      this.$api.get("/adm/com/admUsers").then((r) => {
        this.userName = r.data.userName;
        this.userCode = r.data.userCode;
        if (r.data.pirCode) {
          this.licenseNo = r.data.pirCode + " ";
        } else {
          this.licenseNo = "";
        }
        if (r.data.pptCode) {
             this.license = '｜產險登錄證字號：' + r.data.pptCode;
        }
      });
      this.featchBranCodeRole().then((r) => {
        if (r.data && r.data.length > 0) {
          this.branCodeRoleList = r.data;
          let userInfo = this.$store.getters["user/info"];
          this.branCodeRoleList.forEach((e) => {
            if (
              e.branCode === userInfo.branCode &&
              e.roleCode === userInfo.roleCode
            ) {
              this.branCodeRole = e;
            }
          });
        }
      });

      this.$api.get("/wob/message").then((r) => {
         let len = 0
         let index = 0
        if (r.data.length > 0) {
           let messageArry = r.data
           len = r.data.length
           this.marqueeStr = messageArry[index].msgCont
            setInterval(() => {
             if(index < len) {
               this.marqueeStr = messageArry[index].msgCont
                index ++
             } else {
               index = 0
             }
            }, 3600)
        }
      });

       let userInfo = this.$store.getters["user/info"];
       this.$api.get("/ins/common/insPolicies", {
        params: {
          polState: 'POL_STATEN,POL_STATEO,POL_STATES,POL_STATEU', // 要保書處理進度代碼
          carryYN: userInfo.carryYn, // 是否為攜出裝置
        },
      })
      .then((r) => {
        if (r.data.length > 0) {
            this.searchResult = r.data
          }
      });
      /*
      this.$api.get("/adm/com/inWorkTimInterval").then((r) => {
        if (r.data !== "Y") {
          this.inWorkTime = false;
          this.policyItems = [];
        } else {
          this.inWorkTime = true;

          this.$api
            .get("/ins/insPolicies/walkOutData", {
              params: {
                status: ["S"],
                userCode: "",
                needPolBranCode: true,
              },
            })
            .then((r) => {
              var found = false;
              this.policyItems = r.data;
              for (var i = 0; i < r.data.length; i++) {
                if (r.data[i].polState === "S") {
                  found = true;
                  break;
                }
              }
              if (found) {
                this.$alert(
                  "提醒您!您有已簽名未上傳之案件，為避免保戶權益受損，請盡速完成上傳，謝謝"
                );
              }
            });
        }
      });
      */
    },
    insStepHandler({ progClassName, methodName, stepCode, woCode }) {
      this.$store
        .dispatch("common/postUserAccessLog", {
          transCode: this.transCode,
          actionMsg: "",
          progClassName: progClassName,
          methodName: methodName,
          sysType: "F",
          stepCode: stepCode,
          woCode: woCode,
        })
        .then((r) => {});
    },
    getUserCerProStr(cerProYnList) {
      let msgAry = [];
      if (cerProYnList && cerProYnList.length > 0) {
        cerProYnList.forEach((e) => {
          if (e.resultYn === "Y") {
            if (e.proTypeCode === "P106") {
              // 傳統型銷售資格
              msgAry.push("傳統型銷售資格");
            }
            if (e.proTypeCode === "P107") {
              // 投資型證照資格
              msgAry.push("投資型證照資格");
            }
            if (e.proTypeCode === "P108") {
              // 投資型年金銷售資格
              msgAry.push("投資型年金銷售資格");
            }
            if (e.proTypeCode === "P109") {
              // 傳統型年金銷售資格
              msgAry.push("傳統型年金銷售資格");
            }
            if (e.proTypeCode === "P110") {
              // 外幣證照資格
              msgAry.push("外幣證照資格");
            }
          }
        });
      }
      return msgAry.join(" | ");
    },
    lang(){
      if(this.intervalId != null ) return;

      this.intervalId = setInterval(() => {
        //得到第一個字元
        var start = this.wobMsg.substring(0,1)
       //得到最後一個字元
        var end = this.wobMsg.substring(1)
        //後面與前面字元連接
        this.wobMsg = end + start
      },600)
    },
     replace(val) {
      val = val.split('<br>').join('\r\n')
      return val;
    }
  },
};
</script>
<style lang="stylus" scoped>
.home{
  position relative
}
.primary-title {
  font-size: $font-size-ml;
  font-weight: bold;
  letter-spacing: 1.29px;
  color: #111111;
  text-align: left;
  margin-top: 40px;
  margin-bottom: 20px;
}

.title-name {
  font-size: $font-size-md;
  font-weight: bold;
  letter-spacing: 1.6px;
  color: $accent-color;
}

.border-active {
  background-color: #fff;
  border: 2px solid #fff;
}

.border-active:hover {
  border-color: $accent-color !important;
  border-radius: 5px;
}
.d-content {
  color: $border-color;
  display: contents;

  span+span {
    border-left: 1px solid $border-color;
    padding: 0 10px;
  }
}

.date-sm {
  font-size: $font-size-sm;
  color: $border-color;
}

.name {
  font-size: $font-size-md;
  font-weight: bolder;
  width: 97px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list-data {
  height: 60px;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 10px;
  margin-top: 4px;

  &:hover {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
}

.read-more {
  color: $accent-color;
  font-weight: bold;
  font-size: $font-size-md;
}

/* 样式2 */
@media (min-width: 1264px) and (max-width: 1356px) {
  .name, .date-sm {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@media (min-width: 1264px) and (max-width: 1300px) {
  .name, .date-sm {
    width: 60px;
  }
}

@media (min-width: 1300px) and (max-width: 1356px) {
  .name, .date-sm {
    width: 70px;
  }
}
</style>
